import { format as dformat, toZonedTime } from 'date-fns-tz'
import { da, de, enGB, nl } from 'date-fns/locale'
import { SiteLanguage } from '../data/models/locale'
import { store } from '../store/store'

const dateLocales: { [key: string]: any } = {
  en: enGB,
  nl,
  de,
  dk: da,
}

export enum Weekdays {
  SUNDAY = 0,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
}

export function getDateLocale(): any {
  const state = store.getState()
  const lang = (state.locale.language || SiteLanguage.en).substr(0, 2)

  return dateLocales[lang]
}

export function isValidDateString(dateString?: Date | string | null): boolean {
  const timestamp = dateString ? Date.parse(`${dateString}`) : NaN
  return !isNaN(timestamp)
}

/**
 * Format using current site locale
 * @param {string | Date} date
 * @param {string} dateFormat
 */
export function format(
  date: number | Date,
  dateFormat: string | DateFormatType,
  timeZone?: string,
) {
  let realFormat: string
  if (typeof dateFormat === 'string') {
    realFormat = dateFormat
  } else {
    realFormat = getFormat(dateFormat)
  }
  if (timeZone) {
    date = toZonedTime(date, timeZone)
  }

  return dformat(new Date(date), realFormat, { locale: getDateLocale() })
}

export enum DateFormatType {
  day,
  date,
  daymonth,
  daymonthShort,
  monthYear,
  datetime,
  datetimetz,
  apidate,
}

export function getFormat(dateFormat: DateFormatType): string {
  const state = store.getState()
  const lang = (state.locale.language || SiteLanguage.en).substr(0, 2)

  switch (dateFormat) {
    case DateFormatType.day:
      if (lang === 'en') {
        return 'do'
      } else {
        return 'd'
      }
    case DateFormatType.date:
      if (lang === 'en') {
        return 'do MMMM yyyy'
      } else {
        return 'd MMMM yyyy'
      }
    case DateFormatType.daymonth:
      if (lang === 'en') {
        return "do 'of' MMMM"
      } else {
        return 'd MMMM'
      }
    case DateFormatType.daymonthShort:
      if (lang === 'en') {
        return 'do MMMM'
      } else {
        return 'd MMMM'
      }
    case DateFormatType.monthYear:
      return 'MMMM yyyy'
    case DateFormatType.datetime:
      if (lang === 'en') {
        return "EEEE do MMMM 'at' H:mm"
      } else {
        return "EEEE d MMMM 'om' H:mm"
      }
    case DateFormatType.datetimetz:
      if (lang === 'en') {
        return "EEEE do MMMM 'at' H:mm (z)"
      } else {
        return "EEEE d MMMM 'om' H:mm (z)"
      }
    case DateFormatType.apidate:
      return 'yyyy-MM-dd'
  }
}

export function diffDays(firstDate: Date, secondDate: Date): number {
  const oneDay = 24 * 60 * 60 * 1000

  return Math.round((secondDate.getTime() - firstDate.getTime()) / oneDay)
}
